/**
 * Deoxylocks Ambassador Page
 */

(function () {
  'use strict';

  var page = document.getElementById('ambassador-page');
  if (!page) return;

  var CLOUDINARY_CLOUD   = page.dataset.cloudinaryCloud   || '';
  var CLOUDINARY_PRESET  = page.dataset.cloudinaryPreset  || '';

  var W3F_REVIEW  = '28b6de37-be4f-4f4e-929a-f5f4ff04d208';
  var W3F_PARTNER = '3eed53f3-3767-48e3-ad78-fa725ab25f6a';

  var selectedReviewPhotos = [];

  // ── Smooth scroll ────────────────────────────────────────
  function scrollTo(id) {
    var el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  page.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-scroll-to]');
    if (btn) { e.preventDefault(); scrollTo(btn.dataset.scrollTo); }
  });

  // ── FAQ accordion ────────────────────────────────────────
  page.querySelectorAll('.faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item   = btn.closest('.faq-item');
      var isOpen = item.classList.contains('is-open');
      page.querySelectorAll('.faq-item.is-open').forEach(function (open) {
        open.classList.remove('is-open');
        open.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
        open.querySelector('.faq-tog').textContent = '+';
      });
      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
        btn.querySelector('.faq-tog').textContent = '–';
      }
    });
  });

  // ── Web3Forms submission ─────────────────────────────────
  function submitToWeb3Forms(accessKey, fields) {
    fields.access_key = accessKey;
    return fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(fields),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || !data.success) throw new Error(data.message || 'Web3Forms error');
      });
    });
  }

  // ── Chip selects ─────────────────────────────────────────
  function initChips() {
    page.querySelectorAll('.chips').forEach(function (group) {
      var isMulti = group.dataset.multi === 'true';
      group.querySelectorAll('.chip').forEach(function (chip) {
        chip.addEventListener('click', function () {
          if (isMulti) {
            chip.classList.toggle('is-active');
            updateChipIcon(chip);
          } else {
            group.querySelectorAll('.chip').forEach(function (c) {
              c.classList.remove('is-active');
              updateChipIcon(c);
            });
            chip.classList.add('is-active');
            updateChipIcon(chip);
          }
        });
      });
      // initialise icons for pre-selected chips
      group.querySelectorAll('.chip.is-active').forEach(updateChipIcon);
    });
  }

  function updateChipIcon(chip) {
    var existing = chip.querySelector('svg');
    if (chip.classList.contains('is-active')) {
      if (!existing) {
        var svg  = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('width', '11'); svg.setAttribute('height', '11');
        svg.setAttribute('viewBox', '0 0 14 14'); svg.setAttribute('fill', 'none');
        svg.setAttribute('aria-hidden', 'true');
        var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', 'M2 7.5 L5.5 11 L12 3.5');
        path.setAttribute('stroke', 'currentColor'); path.setAttribute('stroke-width', '1.6');
        path.setAttribute('stroke-linecap', 'round'); path.setAttribute('stroke-linejoin', 'round');
        svg.appendChild(path);
        chip.insertBefore(svg, chip.firstChild);
      }
    } else {
      if (existing) existing.remove();
    }
  }

  function getChipValue(groupId) {
    var group = document.getElementById(groupId);
    if (!group) return '';
    return Array.from(group.querySelectorAll('.chip.is-active'))
      .map(function (c) { return c.dataset.value; }).join(', ');
  }

  // ── Shared helpers ───────────────────────────────────────
  function val(id) { return (document.getElementById(id) || {}).value || ''; }
  function checked(id) { return !!((document.getElementById(id) || {}).checked); }

  function setErr(id, msg) {
    var el = document.getElementById(id);
    if (el) el.textContent = msg ? ' · ' + msg : '';
  }

  // ── Review Gift form ─────────────────────────────────────
  function initReviewForm() {
    var submitBtn = document.getElementById('amb-review-submit');
    if (!submitBtn) return;

    var reviewTextArea = document.getElementById('review-reviewText');
    if (reviewTextArea) {
      reviewTextArea.addEventListener('input', function () {
        var counter = document.getElementById('review-text-count');
        if (counter) counter.textContent = reviewTextArea.value.length + ' / 1000';
      });
    }

    var starGroup = document.getElementById('review-stars');
    if (starGroup) {
      starGroup.addEventListener('click', function (e) {
        var btn = e.target.closest('.star');
        if (!btn) return;
        var val = parseInt(btn.dataset.value, 10);
        starGroup.querySelectorAll('.star').forEach(function (s) {
          s.classList.toggle('is-active', parseInt(s.dataset.value, 10) <= val);
        });
        starGroup.dataset.selected = val;
      });
    }

    submitBtn.addEventListener('click', function () {
      if (!validateReviewForm()) return;
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting…';
      submitReviewForm()
        .then(showReviewSuccess)
        .catch(function (err) {
          console.error('[Deoxylocks Amb] Review submit failed:', err);
          submitBtn.disabled = false;
          submitBtn.innerHTML = '<span class="btn-dot"></span> Try Again';
        });
    });
  }

  function validateReviewForm() {
    var valid  = true;
    var checks = [
      ['err-review-fullName',    !val('review-fullName').trim(),                        'Required'],
      ['err-review-email',       !/^\S+@\S+\.\S+$/.test(val('review-email')),          'Enter a valid email'],
      ['err-review-orderNumber', false, ''],
      ['err-review-reviewText',  !val('review-reviewText').trim(),                      'Please share your feedback'],
      ['err-review-stars',       !document.getElementById('review-stars').dataset.selected, 'Please select a rating'],
      ['err-review-address1',    !val('review-address1').trim(),                        'Required'],
      ['err-review-city',        !val('review-city').trim(),                            'Required'],
      ['err-review-zip',         !val('review-zip').trim(),                             'Required'],
      ['err-review-ackTerms',    !checked('review-ackTerms'),                          'Please confirm to continue'],
    ];
    checks.forEach(function (c) {
      if (c[1]) { setErr(c[0], c[2]); valid = false; } else setErr(c[0], '');
    });
    return valid;
  }

  function getReviewData() {
    var nameParts = val('review-fullName').trim().split(' ');
    return {
      firstName:  nameParts[0] || '',
      lastName:   nameParts.slice(1).join(' '),
      fullName:   val('review-fullName'),
      email:      val('review-email'),
      orderNumber: val('review-orderNumber'),
      reviewText:  val('review-reviewText'),
      starRating:  document.getElementById('review-stars').dataset.selected || '',
      address1:   val('review-address1'),
      address2:   val('review-address2'),
      city:       val('review-city'),
      state:      val('review-state'),
      zip:        val('review-zip'),
      country:    val('review-country'),
    };
  }

  function uploadPhotosToCloudinary(files) {
    if (!files.length || !CLOUDINARY_CLOUD || !CLOUDINARY_PRESET) return Promise.resolve([]);
    var uploads = files.map(function (file) {
      var fd = new FormData();
      fd.append('file', file);
      fd.append('upload_preset', CLOUDINARY_PRESET);
      return fetch('https://api.cloudinary.com/v1_1/' + CLOUDINARY_CLOUD + '/image/upload', {
        method: 'POST', body: fd
      })
        .then(function (r) { return r.json(); })
        .then(function (data) { return data.secure_url || ''; })
        .catch(function () { return ''; });
    });
    return Promise.all(uploads);
  }

  function initPhotoUpload() {
    var dropzone  = document.getElementById('review-photo-dropzone');
    var fileInput = document.getElementById('review-photo-input');
    var previews  = document.getElementById('review-photo-previews');
    if (!dropzone || !fileInput || !previews) return;

    function addFiles(files) {
      Array.prototype.forEach.call(files, function (file) {
        if (selectedReviewPhotos.length >= 3) return;
        if (!file.type.match(/^image\//)) return;
        selectedReviewPhotos.push(file);
        var reader = new FileReader();
        reader.onload = function (e) {
          var idx = selectedReviewPhotos.indexOf(file);
          var thumb = document.createElement('div');
          thumb.className = 'photo-thumb';
          thumb.dataset.idx = idx;
          thumb.innerHTML =
            '<img src="' + e.target.result + '" alt="Preview">'
            + '<button type="button" class="photo-thumb-remove" aria-label="Remove photo">&times;</button>';
          previews.appendChild(thumb);
          updateDropzone();
        };
        reader.readAsDataURL(file);
      });
    }

    function updateDropzone() {
      dropzone.style.display = selectedReviewPhotos.length >= 3 ? 'none' : '';
    }

    previews.addEventListener('click', function (e) {
      var btn = e.target.closest('.photo-thumb-remove');
      if (!btn) return;
      var thumb = btn.closest('.photo-thumb');
      var idx = parseInt(thumb.dataset.idx, 10);
      selectedReviewPhotos.splice(idx, 1);
      previews.querySelectorAll('.photo-thumb').forEach(function (t, i) { t.dataset.idx = i; });
      thumb.remove();
      updateDropzone();
    });

    dropzone.addEventListener('click', function () { fileInput.click(); });
    fileInput.addEventListener('change', function () { addFiles(fileInput.files); fileInput.value = ''; });
    dropzone.addEventListener('dragover', function (e) { e.preventDefault(); dropzone.classList.add('is-dragover'); });
    dropzone.addEventListener('dragleave', function () { dropzone.classList.remove('is-dragover'); });
    dropzone.addEventListener('drop', function (e) {
      e.preventDefault(); dropzone.classList.remove('is-dragover');
      addFiles(e.dataTransfer.files);
    });
  }

  function submitReviewForm() {
    var d = getReviewData();
    return uploadPhotosToCloudinary(selectedReviewPhotos).then(function (photoUrls) {
      var fields = {
        subject: 'New Review Gift Submission – ' + d.fullName,
        from_name: d.fullName,
        Name: d.fullName, Email: d.email, 'Order Number': d.orderNumber,
        'Star Rating': d.starRating, 'Review': d.reviewText,
        'Address': d.address1, 'Address 2': d.address2,
        'City': d.city, 'State': d.state, 'ZIP': d.zip, 'Country': d.country,
      };
      if (photoUrls[0]) fields['Photo 1'] = photoUrls[0];
      if (photoUrls[1]) fields['Photo 2'] = photoUrls[1];
      if (photoUrls[2]) fields['Photo 3'] = photoUrls[2];
      return submitToWeb3Forms(W3F_REVIEW, fields);
    });
  }

  function showReviewSuccess() {
    var card      = document.getElementById('amb-review-card');
    if (!card) return;
    var d         = getReviewData();
    var firstName = d.firstName || 'friend';
    var bodyText  = page.dataset.reviewSuccessBody || 'Your derma roller will ship within 5 to 7 business days to the address you provided.';
    card.innerHTML =
      '<div class="track-success">'
      + '<div class="success-mark"><svg viewBox="0 0 48 48" width="48" height="48" fill="none" aria-hidden="true">'
      + '<circle cx="24" cy="24" r="22" stroke="currentColor" stroke-width="1.2"/>'
      + '<path d="M14 24 L21 31 L34 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
      + '</svg></div>'
      + '<span class="eyebrow">— GIFT CLAIMED</span>'
      + '<h3 class="track-h2">Thank you, ' + firstName + '.</h3>'
      + '<p class="track-sub">' + bodyText + '</p>'
      + '</div>';
  }

  // ── Partner Application form ─────────────────────────────
  var partnerStep = 0;

  function initPartnerForm() {
    var nextBtn = document.getElementById('amb-partner-next');
    var backBtn = document.getElementById('amb-partner-back');
    if (!nextBtn) return;

    showPartnerStep(0);

    var whyArea = document.getElementById('p-why');
    if (whyArea) {
      whyArea.addEventListener('input', function () {
        var counter = document.getElementById('p-why-count');
        if (counter) counter.textContent = whyArea.value.length + ' / 600';
      });
    }

    nextBtn.addEventListener('click', function () {
      if (!validatePartnerStep(partnerStep)) return;
      if (partnerStep === 3) {
        nextBtn.disabled = true;
        nextBtn.textContent = 'Submitting…';
        submitPartnerForm()
          .then(showPartnerSuccess)
          .catch(function (err) {
            console.error('[Deoxylocks Amb] Partner submit failed:', err);
            nextBtn.disabled = false;
            nextBtn.innerHTML = '<span class="btn-dot"></span> Try Again';
          });
      } else {
        partnerStep = Math.min(3, partnerStep + 1);
        if (partnerStep === 3) buildReviewSummary();
        showPartnerStep(partnerStep);
      }
    });

    backBtn.addEventListener('click', function () {
      partnerStep = Math.max(0, partnerStep - 1);
      showPartnerStep(partnerStep);
    });
  }

  function showPartnerStep(step) {
    page.querySelectorAll('.amb-step').forEach(function (s, i) {
      s.style.display = (i === step) ? '' : 'none';
    });

    page.querySelectorAll('.apply-pip').forEach(function (pip, i) {
      pip.classList.remove('is-active', 'is-done');
      var n = pip.querySelector('.pip-n');
      if (i < step) {
        pip.classList.add('is-done');
        if (n) n.innerHTML =
          '<svg width="11" height="11" viewBox="0 0 14 14" fill="none" aria-hidden="true">'
          + '<path d="M2 7.5 L5.5 11 L12 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>'
          + '</svg>';
      } else {
        if (n) n.textContent = String(i + 1).padStart(2, '0');
        if (i === step) pip.classList.add('is-active');
      }
    });

    var fill = document.getElementById('amb-progress-fill');
    if (fill) fill.style.width = (step / 3 * 100) + '%';

    var label = document.getElementById('amb-step-label');
    if (label) label.textContent = 'Step ' + (step + 1) + ' of 4';

    var back = document.getElementById('amb-partner-back');
    if (back) back.disabled = (step === 0);

    var next = document.getElementById('amb-partner-next');
    if (next && step === 3) {
      var submitLabel = page.dataset.partnerSubmitLabel || 'Apply Now, It Takes 2 Minutes';
      next.innerHTML = '<span class="btn-dot"></span> ' + submitLabel;
    } else if (next) {
      next.innerHTML = '<span class="btn-dot"></span> Continue';
    }
  }

  function validatePartnerStep(step) {
    var valid = true;
    if (step === 0) {
      var checks = [
        ['err-p-fullName', !val('p-fullName').trim(),                      'Required'],
        ['err-p-email',    !/^\S+@\S+\.\S+$/.test(val('p-email')),        'Enter a valid email'],
        ['err-p-phone',    !val('p-phone').trim(),                         'Required'],
      ];
      checks.forEach(function (c) {
        if (c[1]) { setErr(c[0], c[2]); valid = false; } else setErr(c[0], '');
      });
    }
    if (step === 1) {
      var ig = val('p-instagram').trim();
      var tt = val('p-tiktok').trim();
      var yt = val('p-youtube').trim();
      if (!ig && !tt && !yt) { setErr('err-p-instagram', 'Add at least one handle'); valid = false; }
      else setErr('err-p-instagram', '');
    }
    if (step === 2) {
      var why = val('p-why');
      if (why.trim().length < 30) { setErr('err-p-why', 'A few sentences please (30+ characters)'); valid = false; }
      else setErr('err-p-why', '');
    }
    if (step === 3) {
      if (!checked('p-ackDisclose')) { setErr('err-p-ackDisclose', 'Please confirm'); valid = false; }
      else setErr('err-p-ackDisclose', '');
    }
    return valid;
  }

  function getPartnerData() {
    var nameParts = val('p-fullName').trim().split(' ');
    return {
      firstName: nameParts[0] || '',
      lastName:  nameParts.slice(1).join(' '),
      fullName:  val('p-fullName'),
      email:     val('p-email'),
      phone:     val('p-phone'),
      instagram: val('p-instagram'),
      tiktok:    val('p-tiktok'),
      youtube:   val('p-youtube'),
      website:   val('p-website'),
      followers: getChipValue('p-followers-chips'),
      content:   getChipValue('p-content-chips'),
      usedBefore:getChipValue('p-used-chips'),
      why:       val('p-why'),
      video:     getChipValue('p-video-chips'),
    };
  }

  function buildReviewSummary() {
    var summary = document.getElementById('amb-review-summary');
    if (!summary) return;
    var d = getPartnerData();
    var rows = [
      ['Name',        d.fullName],
      ['Email',       d.email],
      ['Phone',       d.phone],
      ['Instagram',   d.instagram ? '@' + d.instagram : ''],
      ['TikTok',      d.tiktok    ? '@' + d.tiktok    : ''],
      ['YouTube',     d.youtube   ? '@' + d.youtube   : ''],
      ['Website',     d.website],
      ['Followers',   d.followers],
      ['Content',     d.content],
      ['Used before', d.usedBefore],
      ['Why',         d.why],
      ['Video',       d.video],
    ];
    summary.innerHTML = rows.filter(function (r) { return r[1]; }).map(function (r) {
      return '<div class="review-row">'
        + '<span class="review-l">' + r[0] + '</span>'
        + '<span class="review-v">' + r[1] + '</span>'
        + '</div>';
    }).join('');
  }

  function submitPartnerForm() {
    var d = getPartnerData();
    return submitToWeb3Forms(W3F_PARTNER, {
      subject: 'New Ambassador Application – ' + d.fullName,
      from_name: d.fullName,
      Name: d.fullName, Email: d.email, Phone: d.phone,
      Instagram: d.instagram ? '@' + d.instagram : '',
      TikTok: d.tiktok ? '@' + d.tiktok : '',
      YouTube: d.youtube ? '@' + d.youtube : '',
      Website: d.website, Followers: d.followers,
      'Content Styles': d.content, 'Used Before': d.usedBefore,
      'Why Partner': d.why, 'Video Comfort': d.video,
    });
  }

  function showPartnerSuccess() {
    var card = document.getElementById('amb-partner-card');
    if (!card) return;
    var d         = getPartnerData();
    var firstName = d.firstName || 'friend';
    card.innerHTML =
      '<div class="apply-body"><div class="track-success">'
      + '<div class="success-mark"><svg viewBox="0 0 48 48" width="48" height="48" fill="none" aria-hidden="true">'
      + '<circle cx="24" cy="24" r="22" stroke="currentColor" stroke-width="1.2"/>'
      + '<path d="M14 24 L21 31 L34 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
      + '</svg></div>'
      + '<span class="eyebrow">— APPLICATION RECEIVED</span>'
      + '<h3 class="track-h2">Thank you, ' + firstName + '.</h3>'
      + '<p class="track-sub">We review every application personally. If selected, you\'ll hear from us within 7 days at ' + d.email + '.</p>'
      + '</div></div>';
  }

  // ── Scroll animations ────────────────────────────────────
  function initAnimations() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el    = entry.target;
          var delay = el.dataset.delay;
          if (delay) el.style.transitionDelay = delay + 'ms';
          el.classList.add('anim--visible');
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.15 });

    page.querySelectorAll('.anim').forEach(function (el) { observer.observe(el); });
  }

  // ── Init ─────────────────────────────────────────────────
  initChips();
  initPhotoUpload();
  initReviewForm();
  initPartnerForm();
  initAnimations();

})();
